import { haversineDistanceMeters } from './geo';
import type { Landmark } from '../types';

/**
 * Returns the first landmark within radiusMeters of (lat, lng),
 * or null if none found.
 */
export function findNearbyLandmark(
  lat: number,
  lng: number,
  landmarks: Landmark[],
  radiusMeters: number
): Landmark | null {
  for (const lm of landmarks) {
    const dist = haversineDistanceMeters(lat, lng, lm.lat, lm.lng);
    if (dist <= radiusMeters) return lm;
  }
  return null;
}
